import { AuthProvider } from '@deltasuite/auth';
import { AppShell } from './AppShell';
import { AuthBridge } from './auth/AuthBridge';
import { AuthGate } from './auth/AuthGate';
import { AuthMisconfigured } from './auth/AuthMisconfigured';
import { buildAuthConfig, isAuthConfigured, missingProdEnvVars } from './auth/config';

// Three render paths:
//
// 1. Production build (import.meta.env.PROD) with any required env var
//    missing: hard-fail with <AuthMisconfigured/>. Silently dropping to
//    the dev fallback on a misconfigured prod deploy is exactly the kind
//    of quiet auth bypass we never want shipping.
// 2. Dev build without auth env: skip the gate; api/client.ts uses
//    X-Dev-User-Id, the worker honours it in non-production. Lets
//    `wrangler dev` + `vite dev` work locally without round-tripping a
//    real magic link.
// 3. Auth env present: <AuthProvider> → <AuthBridge> → <AuthGate> →
//    <AppShell>. The gate decides loading / login / app based on session.
export function App() {
  if (import.meta.env.PROD && missingProdEnvVars().length > 0) {
    return <AuthMisconfigured />;
  }
  if (!isAuthConfigured) {
    return (
      <AuthProvider config={buildAuthConfig()}>
        <AuthBridge>
          <AppShell />
        </AuthBridge>
      </AuthProvider>
    );
  }
  return (
    <AuthProvider config={buildAuthConfig()}>
      <AuthBridge>
        <AuthGate>
          <AppShell />
        </AuthGate>
      </AuthBridge>
    </AuthProvider>
  );
}
